import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  bodyFont, CARD_RADIUS, homeColors, shadowSoftStrong, STAT_CARD_HEIGHT, titleFont,
} from '../style/homeStyles';

// Tarjeta de métrica: en mobile la usa StatsCarousel y en desktop va directo en la grilla.
// isDesktop la hace más alta y centra el label en el espacio que sobra debajo del número.
const StatCard = ({ value, label, isDesktop }) => (
  <Box sx={{
    backgroundColor: homeColors.white,
    borderRadius: CARD_RADIUS,
    padding: isDesktop ? '26px 24px' : '22px',
    minHeight: isDesktop ? STAT_CARD_HEIGHT : 170,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: isDesktop ? 'flex-start' : 'space-between',
    alignItems: 'flex-start',
    textAlign: 'left',
    // La sombra reforzada es parte del rediseño desktop; el carrusel mobile usa la original.
    boxShadow: isDesktop
      ? shadowSoftStrong
      : '0 1px 0 rgba(31,27,29,0.02), 0 10px 20px -14px rgba(31,27,29,0.14)',
    userSelect: 'none',
  }}
  >
    <Typography
      component="span"
      sx={{
        fontFamily: titleFont,
        fontWeight: 700,
        fontSize: isDesktop ? 48 : 42,
        lineHeight: 0.95,
        letterSpacing: '-0.04em',
        color: homeColors.pink,
      }}
    >
      {value}
    </Typography>
    <Typography
      component="span"
      sx={{
        marginTop: isDesktop ? 'auto' : '14px',
        marginBottom: isDesktop ? 'auto' : 0,
        paddingTop: isDesktop ? '14px' : 0,
        fontFamily: bodyFont,
        fontWeight: 400,
        fontSize: isDesktop ? 20 : 13.5,
        lineHeight: 1.4,
        color: homeColors.ink2,
        whiteSpace: 'pre-line',
      }}
    >
      {label}
    </Typography>
  </Box>
);

StatCard.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
};

StatCard.defaultProps = {
  isDesktop: false,
};

export default StatCard;
